<template>
<ins class="adsbygoogle"
     style="display:inline-block;width:728px;height:90px"
     data-ad-client="ca-pub-8850793267495641"
     data-ad-slot="5278413770">
    </ins>
</template>
<script>
export default {
   name: 'adsense',
  mounted() {
    (window.adsbygoogle = window.adsbygoogle || []).push({})
  }
}
</script>
